import './HActivitiesFilterForm.scss';

import * as tsx from 'vue-tsx-support';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import type { HActivitiesFilterProviderRef } from './HActivitiesFilterProvider';
import { HSelect, HSimpleFilterForm, HCheckboxGroup } from '~/components';

export interface HActivitiesFilterFormProps {
  /**
   * 条件変更でリストの内容に変化が発生した際に、一番上のアクティビティまで自動でスクロールさせるか
   */
  useAutoScroll?: boolean;
}

export interface HActivitiesFilterFormEmits {}

export interface HActivitiesFilterFormScopedSlots {}

/**
 * アクティビティリストをフィルタするための条件オを入力するフォーム
 *
 * * `<HActivitiesFilterProvider />` の中でのみ動作するように実装されています
 */
@Component<HActivitiesFilterFormRef>({
  name: 'HActivitiesFilterForm',
  inject: {
    provider: {
      from: 'activitiesFilterProvider',
    },
  },

  render() {
    const { provider } = this;

    return (
      <HSimpleFilterForm
        staticClass="h-activities-filter"
        count={provider.count}
        onClickReset={this.reset}>
        <HSelect
          staticClass="h-activities-filter__control"
          v-model={this.month}
          label={this.$t('label.period') as string}
          color="default"
          items={provider.periodOptions}
        />

        {this.showTargetAgeFilter && (
          <HCheckboxGroup
            staticClass="h-activities-filter__control"
            v-model={this.targetAges}
            label={this.$t('label.appropriateAge') as string}
            items={provider.targetAgeOptions}
            size="sm"
          />
        )}
        {/* キーワード登録がなければ表示しない */}
        {!!provider.keywordOptions.length && (
          <HCheckboxGroup
            staticClass="h-activities-filter__control"
            v-model={this.keywords}
            label={this.$t('label.keyword') as string}
            items={provider.keywordOptions}
            size="sm"
          />
        )}
      </HSimpleFilterForm>
    );
  },
})
export class HActivitiesFilterFormRef
  extends Vue
  implements HActivitiesFilterFormProps {
  readonly provider!: HActivitiesFilterProviderRef;

  @Prop(Boolean) readonly useAutoScroll!: boolean;

  /** Alias */
  get month() {
    return this.provider.month;
  }

  set month(month) {
    this.provider.setValue('month', month, this.useAutoScroll);
  }

  /** Alias */
  get targetAges() {
    return this.provider.targetAges;
  }

  set targetAges(targetAges) {
    this.provider.setValue('targetAges', targetAges, this.useAutoScroll);
  }

  get keywords() {
    return this.provider.keywords;
  }

  set keywords(keywords) {
    this.provider.setValue('keywords', keywords, this.useAutoScroll);
  }

  /** CMSで対象年齢が[大人]しか選択されていない時に絞り込みフィルターを表示 */
  get showTargetAgeFilter() {
    const { targetAgeOptions } = this.provider;
    return (
      targetAgeOptions.length > 0 &&
      !targetAgeOptions.every((v) => v.value === '6')
    );
  }

  reset() {
    return this.provider.reset(this.useAutoScroll);
  }
}

export const HActivitiesFilterForm = tsx
  .ofType<
    HActivitiesFilterFormProps,
    HActivitiesFilterFormEmits,
    HActivitiesFilterFormScopedSlots
  >()
  .convert(HActivitiesFilterFormRef);
